<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Choose Closer:';
                }
            },
            component_id: {
                default(){
                    return 'closer';
                }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/hardware/';
            },
            passed_filter(){
                return this.variable_ready();
            },
            url(){
                return '/api/options/' + this.fabricator + '/closer';
            },
            cache_key(){
                return '_';
            }
        },
    }
</script>
